<template>
  <div>
    <Notification
      :notification="notification"
    >
      <div>
        <MissionNotificationCardContent
          v-if="notification.type === 'mission'"
          :notification="notification"
        />
        <AnalysisNotificationCardContent
          v-if="notification.type === 'analysis'"
          :notification="notification"
        />
      </div>
    </Notification>
  </div>
</template>
<script>
import { STATUS } from '../../store/notifications';
import AnalysisNotificationCardContent from './AnalysisNotificationCardContent';
import MissionNotificationCardContent from './MissionNotificationCardContent';
import Notification from './Notification';

export default {
  name: 'NotificationCard',
  components: {
    AnalysisNotificationCardContent,
    MissionNotificationCardContent,
    Notification,
  },
  computed: {
    cardClasses() {
      if (this.notification.metadata.status === 'clicked') {
        return 'notification-clicked ';
      }
      return 'notification-new ';
    },
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  methods: {
    markClicked() {
      this.$emit('newStatus', {
        status: STATUS.clicked,
        notification: this.notification,
      });
    },
    markSilenced() {
      this.$emit('newStatus', {
        status: STATUS.silenced,
        notification: this.notification,
      });
    },
  },
};
</script>
<style scoped>
.notification-clicked {
  background-color: white;
}

.notification-new {
  background-color: #e8e8e8;
}
</style>
